export const mockClusters = [
    {
        id: 'development',
        name: 'Development',
        icon: '💻',
        description: 'The engine room of innovation. We build robust, scalable, and user-centric applications that solve real-world problems.',
        foundation: 'Founded on the belief that software has the power to transform lives. We aim to bridge the gap between theoretical knowledge and practical application by building real products.',
        focusAreas: ['Full Stack Web Development', 'App Development', 'System Architecture', 'DevOps'],
        technologies: ['React', 'Node.js', 'Flutter', 'Docker', 'AWS'],
        gradient: 'from-cyan-500 to-blue-600',
        border: 'border-cyan-500/30',
        text: 'text-cyan-400',
    },
    {
        id: 'ai',
        name: 'AI & Machine Learning',
        icon: '🧠',
        description: 'Pushing the boundaries of intelligence. We explore the frontiers of AI to create smart systems that learn and adapt.',
        foundation: 'Established to demystify Artificial Intelligence and make it accessible. We believe in the potential of AI to augment human capabilities and solve complex challenges.',
        focusAreas: ['Deep Learning', 'Natural Language Processing', 'Computer Vision', 'Predictive Analytics'],
        technologies: ['Python', 'TensorFlow', 'PyTorch', 'OpenCV', 'Hugging Face'],
        gradient: 'from-purple-500 to-pink-600',
        border: 'border-purple-500/30',
        text: 'text-purple-400',
    },
    {
        id: 'emerging-tech',
        name: 'Emerging Tech',
        icon: '🚀',
        description: 'Exploring the future, today. We dive into cutting-edge technologies that are shaping the next decade of innovation.',
        foundation: 'Born from curiosity about the "next big thing". We provide a sandbox for students to experiment with nascent technologies before they become mainstream.',
        focusAreas: ['Blockchain & Web3', 'IoT & Robotics', 'AR/VR/XR', 'Quantum Computing Concepts'],
        technologies: ['Solidity', 'Arduino', 'Unity', 'Raspberry Pi', 'Unreal Engine'],
        gradient: 'from-green-500 to-teal-600',
        border: 'border-green-500/30',
        text: 'text-green-400',
    },
    {
        id: 'competition',
        name: 'Competition Management',
        icon: '🏆',
        description: 'The strategists and organizers. We design and manage world-class coding competitions and hackathons.',
        foundation: 'Created to foster a competitive spirit and excellence. We believe that healthy competition drives improvement and brings out the best in developers.',
        focusAreas: ['Contest Design', 'Problem Setting', 'Platform Management', 'Event Logistics'],
        technologies: ['HackerRank', 'CodeChef', 'Test Case Generation', 'Event Management Tools'],
        gradient: 'from-orange-500 to-red-600',
        border: 'border-orange-500/30',
        text: 'text-orange-400',
    },
    {
        id: 'programming',
        name: 'Programming',
        icon: '⚡',
        description: 'The algorithmic wizards. We master the art of efficient coding and problem-solving through data structures and algorithms.',
        foundation: 'The bedrock of computer science. We focus on strengthening the fundamental problem-solving skills that are essential for every successful engineer.',
        focusAreas: ['Competitive Programming', 'Data Structures', 'Algorithms', 'Mathematics for CS'],
        technologies: ['C++', 'Java', 'Python', 'STL', 'Graph Theory'],
        gradient: 'from-indigo-500 to-violet-600',
        border: 'border-indigo-500/30',
        text: 'text-indigo-400',
    },
    {
        id: 'media-design',
        name: 'Media & Design',
        icon: '🎨',
        description: 'The creative soul. We blend aesthetics with functionality to create stunning user experiences and visual identities.',
        foundation: 'Recognizing that great technology needs great design. We bridge the gap between engineering and art to create products that are not just functional, but beautiful.',
        focusAreas: ['UI/UX Design', 'Graphic Design', 'Video Editing', 'Brand Identity'],
        technologies: ['Figma', 'Adobe Creative Suite', 'Blender', 'Canva', 'DaVinci Resolve'],
        gradient: 'from-rose-500 to-fuchsia-600',
        border: 'border-rose-500/30',
        text: 'text-rose-400',
    },
    {
        id: 'pr',
        name: 'Public Relations',
        icon: '📢',
        description: 'The voice of the community. We connect the club with the world through storytelling and engagement.',
        foundation: 'Built to amplify our impact. We ensure that the amazing work done by our members reaches a wider audience and inspires others.',
        focusAreas: ['Social Media Management', 'Content Writing', 'Community Outreach', 'Sponsorships'],
        technologies: ['Social Media Analytics', 'Content Strategy', 'Public Speaking', 'Networking'],
        gradient: 'from-yellow-500 to-amber-600',
        border: 'border-yellow-500/30',
        text: 'text-yellow-400',
    },
];
